/**
 * 身份验证
 * 2017-12-6
 */
"use strict";
angular.module("fauthenticationModule", [
]).
controller("fauthenticationCtrl", ['$scope',function($scope) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {

        };
        $scope.data = {
            listData: [],
        };
        $scope.page = {
            CURRPAGE: 1,
            PAGESIZE: 12,
            PAGECOUNT: 1,
            ITEMCOUNT: 0
        };
    }
    /**
     * [initStatus description] 初始化数据
     */
    function initData() {
    }




}]);
